<script setup>
import CheckoutForm from '../CheckoutForm.vue';
import CouponForm from '../CouponForm.vue';
import ImgVisual from '@/Images/ImgVisual.vue';
import { defineAsyncComponent, ref, toRefs, computed } from 'vue';

import { trans, transChoice } from 'laravel-vue-i18n';

const props = defineProps({
    debug: { type: Boolean, default: false },
    //
    entitlement_id: { type: String },
    entitlement_lookup_key: { type: String },
    offering: { type: Object, },
    success_url: { type: String },
    cancel_url: { type: String },
    coupon: { type: Object },
    has_stripe_coupon: { type: Boolean, default: false },
    has_local_coupon: { type: Boolean, default: false },
    show_stripe_offers: { type: Boolean, default: false },
    //
    layout: { type: Object, default: {} },
    partner_slug: { type: String, default: '' },
    step: { type: Number, default: 1 },
    updateSubscription: { type: Function },
    reloadOffering: { type: Function },
    subscription: { type: Object },
    //
    route_checkout: { type: String },
    route_coupon: { type: String },
    route_coupon_validate: { type: String },
});

// console.error('props.layout.left.img_src', props.layout.left.img_src);

// const layout_left_img_src = ref(null);
// const img_src = props.layout && props.layout.left && props.layout.left.img_src
//     ? await import(/* @vite-ignore */ props.layout.left.img_src)
//     // ? await import(/* webpackPrefetch: true */ props.layout.left.img_src)
//     // ? require(props.layout.left.img_src)
//     : { default: null };
// layout_left_img_src.value = img_src.default;

// const path = "../../../../images/trouver-mon-code-1.png";
// const img_src = props.layout && props.layout.left && props.layout.left.img_src
//     // ? await import("../../../../images/trouver-mon-code-1.png")
//     ? await import(path)
//     : { default: null };
// layout_left_img_src.value = img_src.default;

// const requireImage = defineAsyncComponent(link => import(link));
// console.error('requireImage (1)', path)
// console.error('requireImage (2)', requireImage(path))

const getImageUrl = (link) => {
    // return new URL(link, import.meta.url)
    return new URL(link, import.meta.url).href
}
const layout_left_img_src = props.layout && props.layout.left && props.layout.left.img_src
    ? getImageUrl(props.layout.left.img_src)
    : null;
// console.error('getImageUrl', layout_left_img_src, getImageUrl(props.layout.left.img_src));

// http://127.0.0.1:8000/build/assets/trouver-mon-code-1-ce37f7eb.png
// console.error('layout_left_img_src', layout_left_img_src.value, props.layout.left.img_src);

const { subscription } = toRefs(props);
const emit = defineEmits(['updateSubscription', 'reloadOffering']);
const updateSubscription = (prop, value) => {
    emit('updateSubscription', prop, value)
}
const reloadOffering = (code, callback) => {
    emit('reloadOffering', code, callback)
}

const childCheckout = ref(null);
const childCoupon = ref(null);

defineExpose({
    childCheckout,
    childCoupon
});

// Récupération de la variable 'cpn' depuis l'URL afin de modifier l'affichage le temps que le coupon s'applique 
const urlParams = new URLSearchParams(window.location.search);
const hasCpnParam = computed(() => urlParams.has('cpn'));

</script>

<template>
    <div :class="{ 'flex flex-wrap -mx-3': layout && layout.left }">
        <div v-if="layout && layout.left" class="w-full md:w-1/3 order-2 md:order-1 px-3 mb-6 md:mb-0 " :class="[`
            bg-[${layout.colors.secondary_color}] 
            dark:bg-[${layout.colors.background}]
            text-[${layout.colors.txt_default}]
            dark:text-white
            `]">
            <div class="px-4 pt-12 pb-10">

                <div class="mt-0 leading-tight text-lg font-bold">
                    {{ trans(layout.left.title) }}
                </div>
                <div class="my-6">
                    {{ trans(layout.left.content) }}
                </div>

                <div v-if="layout_left_img_src" class="mt-8">
                    <img :src="layout_left_img_src" />
                </div>

            </div>
        </div>
        <div :class="{ 'w-full md:w-2/3 order-1 md:order-2 px-3 text-center': layout && layout.left }">

            <ImgVisual v-if="!show_stripe_offers" class="mx-auto" />

            <div class="text-center pb-8">
                <Transition>
                    <div v-show="debug || !show_stripe_offers && (has_local_coupon || has_stripe_coupon || !subscription.app_user_coupon_stripe)">
			<template v-if="hasCpnParam">
                            <label for="coupon">
                                <div class="mt-6 text-center text-xl font-bold">
                                    {{ trans('Chargement de votre offre') }}
                                </div>
                                <div class="text-center text-xl font-bold">
                                    {{ trans('Veuillez patienter...') }}
                                </div>
                            </label>

                            <CouponForm ref="childCoupon" :partner="partner_slug" :route_submit="route_coupon_validate" :entitlement_lookup_key="entitlement_lookup_key" :entitlement_id="entitlement_id" :subscription="subscription" @updateSubscription="updateSubscription" @reloadOffering="reloadOffering" :offering="offering" :success_url="success_url" :cancel_url="cancel_url" :coupon="coupon" :has_stripe_coupon="has_stripe_coupon" :has_local_coupon="has_local_coupon" :payment_label="layout.payment_label" :payment_labels="layout.payment_labels" :debug="debug" :force_hide="hasCpnParam" />
                        </template>
			<template v-else>
                        <label for="coupon">
                            <div class="my-6 text-center text-2xl font-bold">
                                {{ trans('Saisissez votre code') }}
                            </div>
                        </label>

                        <CouponForm ref="childCoupon" :partner="partner_slug" :route_submit="route_coupon_validate" :entitlement_lookup_key="entitlement_lookup_key" :entitlement_id="entitlement_id" :subscription="subscription" @updateSubscription="updateSubscription" @reloadOffering="reloadOffering" :offering="offering" :success_url="success_url" :cancel_url="cancel_url" :coupon="coupon" :has_stripe_coupon="has_stripe_coupon" :has_local_coupon="has_local_coupon" :payment_label="layout.payment_label" :payment_labels="layout.payment_labels" :debug="debug" />
			</template>
                    </div>
                </Transition>
                <Transition>
                    <div v-show="debug || step > 0 && (show_stripe_offers || (!has_stripe_coupon && subscription.app_user_coupon_stripe))">
                        <template v-if="show_stripe_offers">
                            <h2 class="mb-6 text-center text-2xl font-bold">
                                {{ trans('Choisissez le forfait qui vous convient') }}
                            </h2>
                            <div class="flex flex-wrap mb-6 text-sm font-semibold max-w-4xl mx-auto">
                                <div class="flex items-start w-full md:w-1/2 px-1 mb-6 md:mb-0 ">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="shrink-0 -mt-1 mr-1 w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                    </svg>
                                    <span class="grow text-sm">
                                        {{ trans('Découvrez les contenus de MeditBe en illimité') }}
                                    </span>
                                </div>
                                <div class="flex items-start w-full md:w-1/2 px-1 text-sm font-semibold">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="shrink-0 -mt-1 mr-1 w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                    </svg>
                                    <span class="grow text-sm">
                                        {{ trans('Des programmes créés avec des praticiens renommés') }}
                                    </span>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <h2 class="my-6 text-center text-2xl font-bold">
                                {{ trans('Votre code est valide !') }}
                            </h2>
                        </template>
                        <CheckoutForm ref="childCheckout" :route_checkout="route_checkout" :subscription="subscription" @updateSubscription="updateSubscription" @reloadOffering="reloadOffering" :offering="offering" :success_url="success_url" :cancel_url="cancel_url" :has_stripe_coupon="has_stripe_coupon" :has_local_coupon="has_local_coupon" :show_stripe_offers="show_stripe_offers" :payment_labels="layout.payment_labels" :layout="layout" :debug="debug" />
                    </div>
                </Transition>
            </div>

            <div class="mt-24 mb-6 text-sm text-left ml-4">
                <div v-if="layout && typeof layout.footer != 'undefined'" class="hidden md:block">
                    {{ trans(layout.footer) }}
                </div>
            </div>
        </div>
    </div>
    <div v-if="layout && typeof layout.footer != 'undefined'" class="md:hidden my-24 text-sm text-left">
        {{ trans(layout.footer) }}
    </div>

</template>
